import { PageShell } from '../components';
import { Hero, PerToolExplainer, PainSections, CloseCTA } from '../components/landing/sections';
import { Pricing } from '../components/Pricing';

/**
 * F3 "Blend": a cinematic painting hero, the per-tool explainer, then one
 * section per pain point (pain, fix, the product on a painting, what you are
 * looking at), pricing, and a painted close. Decided in the Design Studio,
 * 2026-10-04 (.impeccable/mocks/round9-final/f3-blend.html).
 */
export default function LandingPage() {
  return (
    <PageShell>
      <div className="s-wrap">
        <Hero />
        <PerToolExplainer />
        <PainSections />
        <Pricing />
        <CloseCTA />
      </div>
    </PageShell>
  );
}
